/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   detail entity actions
 */

import { createAction } from 'redux-actions'
import {
  CANCEL_FETCHING_ENTITY,
  CLEAR_ENTITY,
  DONE_FETCHING_ENTITY,
  ERROR_FETCHING_ENTITY,
  RECEIVE_ENTITY,
  START_FETCHING_ENTITY,
} from '../constants/index'
import type { selectEntity } from '../selectors/index'

export const cancelFetchingEntity = createAction(CANCEL_FETCHING_ENTITY)
export const startFetchingEntity = createAction<{ key: string }, typeof START_FETCHING_ENTITY>(
  START_FETCHING_ENTITY
)
export const clearEntity = createAction(CLEAR_ENTITY)
export const doneFetchingEntity = createAction(DONE_FETCHING_ENTITY)
export const errorFetchingEntity = createAction<{ error: unknown }, typeof ERROR_FETCHING_ENTITY>(
  ERROR_FETCHING_ENTITY
)
export const receiveEntity = createAction<
  { entity: NonNullable<ReturnType<typeof selectEntity>> },
  typeof RECEIVE_ENTITY
>(RECEIVE_ENTITY)
